import Typography from '@mui/material/Typography';
import { Toggle, Translation } from '@ps/web-shared-components';
import React from 'react';

import {
  TXTCLI_No,
  TXTCLI_Yes,
  TXTWCL_Are_you_a_Politically_Exposed__ELL_1
} from './PepHio.messages.json';
import { wrapper } from './PepHio.scss';

const PepHio: React.FC = () => (
  <>
    <Typography>
      <Translation {...TXTWCL_Are_you_a_Politically_Exposed__ELL_1} />
    </Typography>
    <div className={wrapper}>
      <Toggle
        id="pepYes"
        name="pepHio"
        label={TXTCLI_Yes}
        type="radio"
        value="yes"
        data-testid="pepHioYesId"
      />
      <Toggle
        id="pepNo"
        name="pepHio"
        label={TXTCLI_No}
        type="radio"
        value="no"
        data-testid="pepHioNoId"
      />
    </div>
  </>
);

export default PepHio;
